import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideLink from '../components/GuideLink';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';

const GuideAssessmentOverview: React.FC = () => {
  return (
    <GuidePageLayout
      title="資産管理"
      description="PC等の資産の登録・更新・除却を行う台帳管理機能です。セキュリティチェックの対象管理と連携しています。登録・除却は管理者・管理部門のみ、更新・検索は全ユーザーが操作可能です。"
    >
      <GuideSection title="ガイド一覧">
        <Stack spacing={1.5}>
          <Stack spacing={0.5}>
            <GuideLink to="assessment/register">資産を登録する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              新しい資産（PC等）を台帳に登録します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="assessment/bulk-register">資産を一括登録する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              CSVファイルを使用して複数の資産を一括で登録します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="assessment/update">資産情報を更新する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              既存資産の情報を更新します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="assessment/dispose">資産を除却する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              廃棄・譲渡等により資産を除却処理します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="assessment/detail">資産の詳細情報を確認する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              資産の登録情報を詳細画面で確認します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="assessment/search">資産を検索する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              条件を指定して資産を検索・絞り込みます。
            </Typography>
          </Stack>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideAssessmentOverview;
